import { TRIPADVISOR_RESULTS_SAVE } from "./types";

export function saveTripAdvisorResults({ results }) {
  return { type: TRIPADVISOR_RESULTS_SAVE, results };
}
